var _defs, _circle, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBeemgIconsArrow(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 64 64",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .st0 {\n        fill: none;\n      }\n\n      .st1 {\n        fill: #ffc200;\n      }\n\n      .st2 {\n        clip-path: url(#clippath);\n      }\n    "), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "st0",
    width: 64,
    height: 64
  })))), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    className: "st1",
    cx: 32,
    cy: 32.3,
    r: 29
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    className: "st2"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M32,0C14.4,0,0,14.4,0,32s14.4,32,32,32,32-14.4,32-32S49.6,0,32,0ZM32,60c-15.4,0-28-12.6-28-28S16.6,4,32,4s28,12.6,28,28-12.6,28-28,28ZM45.4,30.6c.8.8.8,2,0,2.8l-10,10c-.4.4-.9.6-1.4.6s-1-.2-1.4-.6c-.8-.8-.8-2,0-2.8l6.6-6.6h-19.2c-1.1,0-2-.9-2-2s.9-2,2-2h19.2l-6.6-6.6c-.8-.8-.8-2,0-2.8.8-.8,2-.8,2.8,0l10,10Z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBeemgIconsArrow);
export default __webpack_public_path__ + "static/media/beemg-icons-arrow.4e897bd045e85fec060a3659a7d4e211.svg";
export { ForwardRef as ReactComponent };